import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { HTMLViewProperties, useHTMLViewProperties } from "./HTMLViewProperties";

import { DraftHTMLViewComponent } from "./DraftHTMLViewComponent";
import { FC } from "react";
import { HTMLView } from "./HTMLView";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const HTMLViewComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, properties, error } = useHTMLViewProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <HTMLView className={className} {...properties}>{children}</HTMLView>
}

Registry.addControl({
    id: "c7d81dff-a32c-4373-8b72-c0c9ab5f1f6f",
    name: "HTML View",
    type: ControlType.HTMLView,
    properties: HTMLViewProperties,
    component: HTMLViewComponent,
    draftComponent: DraftHTMLViewComponent
})
